let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bkswC")).then(() => parcelRequire('lhO3J'));